var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4IconSmGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.685 12c0-.572.095-1.12.265-1.634L3.984 8.102A8.796 8.796 0 0 0 3.08 12c0 1.401.325 2.723.903 3.896l2.964-2.27A5.207 5.207 0 0 1 6.685 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M11.893 6.8c1.241 0 2.363.44 3.244 1.16l2.564-2.56c-1.562-1.36-3.565-2.2-5.808-2.2a8.786 8.786 0 0 0-7.91 4.902l2.967 2.264A5.193 5.193 0 0 1 11.893 6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M11.893 17.2a5.193 5.193 0 0 1-4.943-3.566l-2.966 2.264a8.786 8.786 0 0 0 7.909 4.902c2.15 0 4.201-.763 5.741-2.193L14.82 16.43c-.794.5-1.794.77-2.926.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M20.305 12a7.3 7.3 0 0 0-.2-1.6h-8.212v3.4h4.726c-.236 1.16-.88 2.05-1.8 2.63l2.815 2.177c1.618-1.502 2.67-3.739 2.67-6.607Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4IconSmGoogle);
export default __webpack_public_path__ + "static/media/4-icon-sm-google.38556e9d.svg";
export { ForwardRef as ReactComponent };